import { useLocation } from "react-router";
import { rowColumn } from "../../components/table/Table";
import { AuthorisationLevel } from "../enums/AuthorisationLevel";

const userLinkListTable = (isManager: boolean, hasAuthLevel: boolean): rowColumn[] => {
  return [
    {
      label: "Display name",
      column: "displayName",
      body: (rowData) => <>{rowData.user ? rowData.user.displayName : rowData.displayName}</>,
      type: "string",
      allowSort: true,
      isVisible: true,
    },
    {
      label: "hidden Display name",
      column: "user.displayName",
      type: "string",
      allowSort: true,
      isVisible: false,
    },
    {
      label: "Email",
      column: "userEmail",
      body: (rowData) => <>{rowData.user ? rowData.user.userEmail : rowData.userEmail}</>,
      type: "string",
      allowSort: true,
      isVisible: true,
    },
    {
      label: "hidden Email",
      column: "user.userEmail",
      type: "string",
      allowSort: true,
      isVisible: false,
    },
    {
      label: "Authorisation level",
      column: "authorisationLevel",
      type: "enum",
      enumType: AuthorisationLevel,
      allowSort: true,
      isVisible: hasAuthLevel,
    },
    {
      label: "Account access",
      column: "dateDisabled",
      type: "string",
      allowSort: true,
      body: (rowData) => <>{rowData.isActive ? "Access Permitted" : "Access Denied"}</>,
      isVisible: !hasAuthLevel,
    },
    {
      label: "Actions",

      body: (rowData) => {
        const location = useLocation();
        return <a href={`${location.pathname}/${rowData.id}`}>{isManager ? "Edit Details" : "View Details"}</a>;
      },
    },
  ];
};

export default userLinkListTable;
